module.exports = __webpack_public_path__ + "media/images/Virgin Islands-a30622f8.jpg";